import React from "react";
import { BCMSCurrency } from "@bcm-dev/bcms-vite";
import { Card } from "model";

/**
 * @function TransferReviewDetails
 * @return {React.Component}
 * @exported true
 * @description The main component for TransferReviewDetails
 */
export function TransferReviewDetails(props) {
  const form = props.form ?? {};
  const transferAmount = form.transferAmount instanceof BCMSCurrency ? form.transferAmount.format() : "[$X.XX]" ;
  const fi = form.fi ?? "[FI Name]";
  const fiAddress = form.fiAddress ?? "[123 Main St, City, ST 12345]";
  const city = form.city ?? "[FI City]";
  const state = form.state ?? "[FI State]";
  const zip = form.zip ?? "[FI Zip]";
  const creditCardNum = form.creditCardNum === "" ? "[CardLastFour]" : Card.getMaskedNumberFromNumber(form.creditCardNum)
  const requestDate = form.requestDate === undefined ? "[mmmm dd,yyyy]" : form.requestDate.format("M d, Y");
  const email = form.email ?? "[gwashington@gmail.com]";

  return (
    <div className="transfer-review-details">
      <div className="flex-container flex-vertical content-container text-center trasnfer-amount">
        <span>Transfer Amount</span>
        <span>{transferAmount}</span>
      </div>
      <div className="flex-container flex-vertical content-container text-center financial-institution">
        <span>Financial Institution</span>
        <span>{fi}</span>
      </div>
      <div className="flex-container flex-vertical content-container text-center credit-card">
        <span>Credit Card</span>
        <span>{creditCardNum}</span>
      </div>
      <div className="flex-container flex-vertical content-container text-center address">
        <span>Address</span>
        <span>{fiAddress}, {city}, {state} {zip} </span>
      </div>
      <div className="flex-container flex-vertical content-container text-center request-date">
        <span>Request Date</span>
        <span>{requestDate}</span>
      </div>
      <div className="flex-container flex-vertical content-container text-center confirmation-email-address">
        <span>Confirmation Email Address</span>
        <span>{email}</span>
      </div>
    </div>
  )
}